var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    {
      attrs: {
        disabled: !_vm.tooltip || !_vm.tooltipContent,
        content: _vm.tooltipContent,
        placement: "bottom-end"
      }
    },
    [
      _c("cargo-advance-select", {
        ref: "company",
        style: _vm.customStyle,
        attrs: {
          no: "company",
          "popper-class": _vm.popperClass,
          disabled: _vm.disabled,
          "select-type": _vm.selectTypeNames.basic_data_Company,
          "method-params": _vm.methodParams,
          headers:
            _vm.headers && _vm.headers.length > 0 ? _vm.headers : undefined,
          fields: _vm.fields && _vm.fields.length > 0 ? _vm.fields : undefined,
          "tag-name": _vm.tagName,
          filterable: "",
          "default-value": _vm.defaultValue,
          placeholder: _vm.placeholder || undefined,
          "static-options": _vm.staticOptions,
          "data-filter-function": _vm.dataFilterFunction,
          multiple: _vm.multiple,
          "default-multiple-value": _vm.defaultMultipleValue,
          "latest-used-data-key": _vm.latestUsedDataKey
        },
        on: {
          clear: function($event) {
            return _vm.$emit("clear")
          },
          parentCallBack: _vm.onParentCallBack,
          blur: function($event) {
            return _vm.$emit("blur")
          },
          focus: function($event) {
            return _vm.$emit("focus")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }